import {
  Component,
  Input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { QuicklinkDirective } from 'ngx-quicklink';
import { Button } from '../button/button.component';
import { Card } from '../card/card.component';

@Component({
  selector: 'procure-page-has-error',
  templateUrl: './page-has-error.component.html',
  styleUrl: './page-has-error.component.scss',
  imports: [Button, RouterLink, Card, QuicklinkDirective],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class PageHasError {
  @Input() redirectUrl: string = '/';
  @Input() redirectLabel: string = 'Go to Dashboard';

  readonly retry = output<void>();
}
